module.exports = __webpack_public_path__ + "static/board-17-1feaef9bcfcf7ae4d4efc9cbe9fd5cff.jpg";